import React from 'react'
import {Box, Typography, Card, Divider, Rating, Button, Grid} from "@mui/material";
import useStyles from "../../../../assets/styles/ProgramRatingStyles";
import Logo from '../../../../assets/images/dqCitizenshipLogo.png'
import {useHistory} from "react-router-dom";
import {APP_STATUS} from "../../../../utils/constants";
const DQRatingFullReport = ({ data, actions, options }) => {
    const history = useHistory();
    const classes = useStyles();
    const { pdfUrl, appStatusV3 } = data;
    return (
        <>
            <Box sx={{ backgroundColor:'#F4EEEE', padding:'0px !important' }}>
                <Typography variant="h3" sx={{ textAlign: "center", marginBottom: 8, marginTop:{xs:'55px', sm:'40px'} }} className={classes.title}>
                    Full DQ Alignment Report
                </Typography>
                { appStatusV3 < APP_STATUS.PROGRAM_FULL_REPORT_COMPLETED ?
                    (
                        <Typography variant="h3" sx={{ textAlign: "center", marginBottom: 8, marginTop:{xs:'55px', sm:'40px'} }} className={classes.title}>
                            Full DQ Alignment is Pending Review and it will be available once reviewed by our team!
                        </Typography>
                    )
                    :
                    <div style={{backgroundColor: '#F4EEEE', padding: '20px'}}>
                        <iframe
                            src={pdfUrl}
                            width="100%"
                            height="1190px"
                            title="DQ Standards Conformity Test Report"
                            style={{
                                border: '2px solid #ffffff',
                                borderRadius: '15px',
                                backgroundColor: '#F4EEEE',
                            }}
                        />
                    </div>
                }
            </Box>
        </>
    );
}

export default DQRatingFullReport;
